import { render, staticRenderFns } from "./EditIpSets.vue?vue&type=template&id=a2ae96f8"
import script from "./EditIpSets.vue?vue&type=script&lang=js"
export * from "./EditIpSets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports